module.exports = __webpack_public_path__ + "img/ema.c5172682.webp";